/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react"; 
import { Link } from "react-router-dom";
import axios from 'axios';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";

import { unescapeHtml,ChangeDateStringOnlyDate,LoginAfterCheckLogin } from "../../components/common/Common";
import inquiryIcon from "../../img/icon/icon-stroke-inquiry.svg";
import questionIcon from "../../img/icon/icon-stroke-question.svg";
import answerIcon from "../../img/icon/icon-stroke-answer.svg";

import "../../css/style.css";

const Question = () => {
  const mem_idx = localStorage.getItem("mem_idx");
  LoginAfterCheckLogin(1);  //로그인 상태 점검

  //1:1문의 
  const [varQuestionList,setQuestionList] = useState([]);

  //페이지 조절 변수
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);

  //1:1문의 읽어오기
  const getQuestionList = async () => {
    const sendData = {mem_idx:mem_idx,pageNum:varPageNum,pageSize:varPageSize};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_question_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(varPageNum === 1) {
          if(datas.results?.length > 0) setQuestionList(datas.results);
          setTotalCount(datas.totalcount);
        } else {
          if(datas.results?.length > 0) setQuestionList(varQuestionList.concat(datas.results));
        }
      }
    });
  }
  //최초실행부
  useEffect(() => {
    getQuestionList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('pageNum',varPageNum);
    const showNum = (varPageNum-1)*varPageSize;
    if(varTotalCount > showNum) getQuestionList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum]);  

  const onOpenQuestionHandler = (e) => {
    const questionBox = e.currentTarget;
    if(questionBox.classList.contains('active')) questionBox.classList.remove('active');
    else questionBox.classList.add('active');
    if(questionBox.parentNode.querySelector('.drop-body').style.display === "block")
      questionBox.parentNode.querySelector('.drop-body').style.display = "none";
    else 
      questionBox.parentNode.querySelector('.drop-body').style.display = "block";
  }
  
  return (
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'1:1문의'}/>
        <div className="vh-content-body">
          <div className="form-contoller flex-vertical">
              <Link to={'/QuestionDetail'} className="form-contoller-btn"><img src={inquiryIcon} style={{marginRight:"14px"}} alt=""/>문의하기</Link>
            </div>
          <div className="inquiry-box">
            <div className="inquiry-history">
              <div className="inquiry-content-title mb15">문의 및 답변</div>
              <ul className="inquiry-history-list">
                {varQuestionList?.length === 0?
                  <li style={{position:"relative"}}>
                    <div className="noitems" style={{color:"#999",top:"5px"}}>등록된 1:1문의가 없습니다.</div>
                  </li>

                :
                  varQuestionList.map((question,i)=>(
                    <li key={'question_'+i}>
                      <div className="drop-head" onClick={e=>onOpenQuestionHandler(e)}>
                        <div className="inquiry-head">
                          <div className="inquiry-top">
                            <div className="inquiry-date">{ChangeDateStringOnlyDate(question.board_rdate)}</div>
                            <span className="inquiry-state done">{question.board_status===1?"답변 대기":"답변 완료"}</span>
                          </div>										
                          <div className="inquiry-con">
                            <div className="inquiry-icon"><img src={questionIcon} alt=""/></div>
                            <div className="inquiry-subject form-label">{unescapeHtml(question.board_title)}</div>
                          </div>
                        </div>
                        <div className="drop-body" style={{display:"none"}}>
                          <div className="inquiry-con" style={{marginBottom:"10px"}}>
                            <div className="inquiry-icon"><img src={questionIcon} alt=""/></div>
                            <div className="inquiry-details">{unescapeHtml(question.board_comment)}</div>
                          </div>
                          <div className="inquiry-con">
                            <div className="inquiry-icon"><img src={answerIcon} alt=""/></div>
                            <div className="inquiry-details">{unescapeHtml(question.board_answer)}</div>
                          </div>									
                        </div>
                      </div>
                    </li>
                  ))
                }
              </ul>
              {varPageNum>0&&(varPageNum*varPageSize)>=varTotalCount?null:
                <div>
                  <button className="more-button" onClick={()=>setPageNum(varPageNum=>varPageNum+1)}>More...</button>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Question;